import { Outlet } from "@tanstack/react-router";
import { AppShell } from "./AppShell";
import { useShellConfig } from "./context";

/**
 * The root route's component for every app:
 *
 *   createRootRoute({ component: ShellLayout })
 *
 * Rendering the shell here — rather than around `<RouterProvider>` — is what
 * gives the sidebar's navigation links a router context to read. Wrapping the
 * provider instead throws as soon as the first `<Link>` mounts.
 */
export function ShellLayout() {
  const { brand, nav } = useShellConfig();

  return (
    <AppShell brand={brand} nav={nav}>
      <Outlet />
    </AppShell>
  );
}
